import { render, staticRenderFns } from "./BadgeUpgrade.vue?vue&type=template&id=cb93b308&scoped=true"
import script from "./BadgeUpgrade.vue?vue&type=script&lang=js"
export * from "./BadgeUpgrade.vue?vue&type=script&lang=js"
import style0 from "./BadgeUpgrade.vue?vue&type=style&index=0&id=cb93b308&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb93b308",
  null
  
)

export default component.exports